import { CampaignMapView } from './CampaignMapView/CampaignMapView';
import { LayerMapView } from './LayerMapView/LayerMapView';

import type { SharedMapResponse } from './sharedMap.types';

type Props = {
  data?: SharedMapResponse;
  hasError: boolean;
};

const ERROR_MESSAGE = <p className="sharedMap__error">This shared map link is invalid or has expired.</p>;

export function SharedMap({ data, hasError }: Props): JSX.Element | null {
  if (hasError) {
    return ERROR_MESSAGE;
  }

  if (!data) {
    return null;
  }

  if (data.resourceType === 'campaign') {
    return <CampaignMapView level={data.level} mapData={data.mapData} metrics={data.metrics} style={data.style} />;
  }

  return <LayerMapView layer={data.layer} mapData={data.mapData} style={data.style} />;
}
